export const ERROR_CODES = {
    REQUIRED: 'Field_Required',
    RADIO_BUTTON_REQUIRED: 'Radio_Button_Required',
    CREDITCARD: {
        NAME_ON_CARD: {
            MIN_LETTERS_REQ: 'Name_MinRequired',
            CONTAINS_NUMBERS: 'Name_ContainsNumbers',
            INVALID_CHARACTERS: 'Name_InvalidCharacters',
        },
        NUMBER: {
            INVALID: 'CC_NumberInvalid',
        },
        EXPIRATION: {
            INVALID_FORMAT: 'CC_ExpirationInvalidFormat',
            FUTURE_DATE_REQ: 'CC_ExpirationFutureDateRequired',
        },
        CVV: {
            INVALID_AMEX_CVV: 'CVV_InvalidAmex',
            INVALID_NON_AMEX_CVV: 'CVV_InvalidNonAmex',
        },
    },
    ACH: {
        ROUTING_NUMBER: {
            INVALID: 'ACH_RoutingNumber_Invalid',
        },
        ACCOUNT_NUMBER: {
            INVALID: 'ACH_AccountNumber_Invalid',
        },
        ACCOUNT_DESCRIPTION: {
            REQUIRED: 'ACH_AccountDescription_Required',
            INVALID_CHARACTERS: 'ACH_AccountDescription_InvalidCharacters',
        },
    },
    ADDRESS: {
        STREET_ADDRESS: {
            MIN_LETTERS_REQ: 'Address_StreetAddress_MinRequired',
            INVALID_CHARACTERS: 'Address_StreetAddress_InvalidCharacters',
        },
        STREET_ADDRESS_2: {
            INVALID_CHARACTERS: 'Address_StreetAddress2_InvalidCharacters',
        },
        CITY: {
            MIN_LETTERS_REQ: 'Address_City_MinRequired',
            INVALID_CHARACTERS: 'Address_City_InvalidCharacters',
        },
        STATE: {
            INVALID_CHARACTERS: 'Address_StreetAddress_InvalidCharacters',
            INVALID_SELECTION: 'Address_State_InvalidSelection',
        },
        ZIP_FIVE: {
            FIVE_DIGITS_REQUIRED: 'Address_Zip_FiveDigitsRequired',
        },
    },
};
//# sourceMappingURL=errorCodes.js.map